import { LazyImage } from '@components/common/image'
import TestimonialCard from '@components/common/testimonial-card'

const Testimonials = () => (
  <div className="flex relative flex-col py-5 mx-auto my-10 lg:my-20">
    <LazyImage
      path="/images/book-trial-class/testimonials/"
      name="left-shapes"
      className="hidden absolute top-0 left-0 z-10 lg:flex"
      alt="Background shapes"
    />
    <LazyImage
      path="/images/book-trial-class/testimonials/"
      name="right-shapes"
      className="hidden absolute top-0 right-10 z-10 w-1/4 lg:flex"
      alt="Background shapes"
    />
    <div
      className="hidden absolute top-0 w-full h-full lg:right-0 lg:left-0 lg:mx-auto lg:max-w-6xl lg:rounded-2xl lg:block"
      style={{
        backgroundColor: '#FFEBE5',
      }}
    />
    <div className="flex z-20 flex-col items-center">
      <h1 className="px-10 mx-auto max-w-5xl text-4xl leading-tight text-grey lg:text-left font-700 lg:text-4xl lg:w-full lg:mt-5 lg:mx-0 lg:px-18">
        Testimonials
      </h1>
      <div className="flex flex-col items-center mx-auto max-w-6xl lg:flex-row lg:justify-center lg:flex-wrap">
        <TestimonialCard
          name="sofia"
          imageUrl="/images/book-trial-class/testimonials/"
          content="Two weeks ago, I could not write basic code. But, just after 7 classes at Codingal, I can now build an app"
          role="Sofia"
        />
        <TestimonialCard
          name="advik"
          imageUrl="/images/book-trial-class/testimonials/"
          content="Through Codingal I realised that coding is not something very difficult and complex but actually interesting and fun!"
          role="Advik"
        />
        <TestimonialCard
          name="samar-shareef"
          imageUrl="/images/book-trial-class/testimonials/"
          content="I was especially impressed when the teacher went out of the way and provided extra classes to explain a concept in app development which my son found difficult"
          role="Samar Shareef"
        />
      </div>
    </div>
  </div>
)
export default Testimonials
